import React, {Component, Suspense} from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { CSpinner } from '@coreui/react';

import routes from '../../routes';
import Toasts from "../notificacion/Toasts";
import Socket from "../socket/Socket";
import AuthRoute from "../route/AuthRoute";
import AuthService from "../../services/auth.service";
import { StateContext } from "../context/StateProvider";

class Content extends Component {
    static contextType = StateContext;

    render() {
        const user = AuthService.getCurrentUser();
        const { state } = this.context;

        return (
            <div>
                <Socket />
                <Toasts />
                <Suspense fallback={<CSpinner color="primary" />}>
                    <Routes>
                        {routes.map((route, idx) => (
                            route.element && (
                                <Route
                                    key={idx}
                                    path={route.path}
                                    exact={route.exact}
                                    name={route.name}
                                    element={
                                        <AuthRoute roles={route.roles}>
                                            <route.element key={state.year} />
                                        </AuthRoute>
                                    }
                                />
                            )
                        ))}
                        <Route path="/" element={<Navigate to={user.home} replace />} />
                    </Routes>
                </Suspense>
            </div>
        );
    }
}

export default React.memo(Content);
